import { useFlags } from 'launchdarkly-react-client-sdk';
import React, { useEffect, useRef, useState } from 'react';

import { useMutationUpdateTravellerPosition } from '../../queries/booking/hooks/useMutationUpdateTravellerPosition';
import { GeoMap } from '../geoMap/GeoMap';

export const GeoPoint: any = (props: any) => {
  const {
    position,
    driverPosition,
    center,
    zoom,
    journeyId,
    draggable = true,
    showUserPosition = false,
  } = props;
  const flags = useFlags();
  const [updateTravellerPosition] = useMutationUpdateTravellerPosition();
  const [positionId, setPositionId] = useState<any>();
  const [userPosition, setUserPosition] = useState<any>();
  const markerRef = useRef(null) as any;
  const userPositionIconRef = useRef(null) as any;
  const driverPositionIconRef = useRef(null) as any;
  const mapRef = useRef(null) as any;
  const mapsRef = useRef(null) as any;
  const intervalRef = useRef<any>();

  const handleApiLoaded = ({ map, maps }: any) => {
    mapRef.current = map;
    mapsRef.current = maps;
    if (position?.lat && position?.lng) {
      addMarker({ map, maps }, position);
    }
  };

  useEffect(() => {
    if (driverPosition && mapRef.current) {
      addDriverIcon( { map: mapRef.current });
    }
  }, [driverPosition]);

  useEffect(() => {
    return () => {
      console.log('clear');
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  const haversineDistance = (pos1: any, pos2: any) => {
    // Radius of the Earth in km
    const R = 6371.1;
    // Convert degrees to radians
    const rlat1 = pos1.lat * (Math.PI / 180);
    // Convert degrees to radians
    const rlat2 = pos2.lat * (Math.PI / 180);
    // Radian difference (latitudes)
    const difflat = rlat2 - rlat1;
    // Radian difference (longitudes)
    const difflon = (pos2.lng - pos1.lng) * (Math.PI / 180);

    // eslint-disable-next-line no-mixed-operators
    return 2 * R * Math.asin(Math.sqrt(Math.sin(difflat / 2) * Math.sin(difflat / 2) + Math.cos(rlat1) * Math.cos(rlat2) * Math.sin(difflon / 2) * Math.sin(difflon / 2)));
  };

  const submitTravellerPosition = () => {
    navigator.geolocation.getCurrentPosition(function(userPosition) {
      const userPos = { lat: userPosition.coords.latitude, lng: userPosition.coords.longitude };
      updateTravellerPosition({
        variables: {
          params: {
            position: userPos,
            creationSource: 'WHITE_LABEL',
            journeyId,
          },
        },
      }, () => {
        console.log('INFO traveller position updated');
      });

    });
  };

  const trackTravellerPosition = (): void => {
    if (flags.trackTravellerPosition) {
      submitTravellerPosition();
      intervalRef.current = setInterval(() => {
        submitTravellerPosition();
      }, 15000);
    }
  };

  const addMarker = ({ map, maps }: any, position: any) => {
    if (markerRef.current) {
      markerRef.current.setMap(null);
    }
    if (showUserPosition && flags?.showUserPosition) {
      trackTravellerPosition();
      navigator.geolocation.getCurrentPosition(function(userPosition) {
        const userPos = { lat: userPosition.coords.latitude, lng: userPosition.coords.longitude };
        addUserIcon({ map }, userPos);
        setUserPosition(userPos);
        if (haversineDistance(position, userPos) < 5) {
          const bounds = new maps.LatLngBounds();
          bounds.extend(position);
          bounds.extend({ lat: userPosition.coords.latitude, lng: userPosition.coords.longitude });
          map.fitBounds(bounds);
        }
      });
      const id = navigator.geolocation.watchPosition(function(position) {
        addUserIcon({ map }, { lat: position.coords.latitude, lng: position.coords.longitude });
      });
      setPositionId(id);
    }
    if (markerRef) {
      markerRef.current = new maps.Marker({
        position,
        map,
        draggable,
      });
    }
  };

  const addUserIcon = ({ map }: any, position: any) => {
    if (userPositionIconRef.current) {
      userPositionIconRef.current.setMap(null);
    }
    userPositionIconRef.current = new google.maps.Marker({
      position,
      icon: {
        anchor: new google.maps.Point(16, 16),
        url: 'data:image/svg+xml;utf-8, \
        <svg width="48" height="48" viewBox="0 0 40 40"  xmlns="http://www.w3.org/2000/svg"><circle cx="20" cy="20" r="8" fill="none" stroke="rgb(0, 131, 168)" stroke-width="2"><animate attributeName="r" begin="0s" dur="1.5s" from="8" repeatCount="indefinite" to="20"/><animate attributeName="opacity" begin="0s" dur="1.5s" from="1" repeatCount="indefinite" to="0"/></circle><circle cx="20" cy="20" r="10" fill="rgb(0, 131, 168)"/></svg>',
      },
      map: map,
    });
  };
  const addDriverIcon = ({ map }: any) => {
    let fitBounds = false;
    if (driverPositionIconRef.current) {
      driverPositionIconRef.current.setMap(null);
    } else {
      fitBounds = true;
    }
    const svg = `<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="24" cy="24" r="18" stroke="#9200A9" stroke-width="2"><animate attributeName="r" begin="0s" dur="1.5s" from="8" repeatCount="indefinite" to="23"/><animate attributeName="opacity" begin="0s" dur="1.5s" from="1" repeatCount="indefinite" to="0"/></circle>
        <rect x="9" y="9" width="30" height="30" rx="15" fill="#9200A9"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M28.134 20.8125C28.184 20.8125 28.2319 20.8325 28.2671 20.8679L30.0592 22.6744C30.3056 22.9228 30.6411 23.0625 30.991 23.0625H31.5C31.6036 23.0625 31.6875 23.1464 31.6875 23.25V25.5C31.6875 25.6036 31.6036 25.6875 31.5 25.6875H30.75C30.4393 25.6875 30.1875 25.9394 30.1875 26.25C30.1875 26.5606 30.4393 26.8125 30.75 26.8125H31.5C32.2249 26.8125 32.8125 26.2249 32.8125 25.5V23.25C32.8125 22.5251 32.2249 21.9375 31.5 21.9375H30.991C30.941 21.9375 30.8931 21.9175 30.8579 21.8821L29.0658 20.0756C28.8194 19.8272 28.4839 19.6875 28.134 19.6875H22.75C22.466 19.6875 22.1897 19.7796 21.9625 19.95L19.3298 21.9245C19.3025 21.9451 19.27 21.9577 19.2359 21.9611L17.0448 22.1802C15.9904 22.2856 15.1875 23.1729 15.1875 24.2325V25.5C15.1875 26.2249 15.7751 26.8125 16.5 26.8125H18.75C19.0606 26.8125 19.3125 26.5606 19.3125 26.25C19.3125 25.9394 19.0606 25.6875 18.75 25.6875H16.5C16.3964 25.6875 16.3125 25.6036 16.3125 25.5V24.2325C16.3125 23.7509 16.6775 23.3476 17.1567 23.2997L19.3479 23.0805C19.5861 23.0567 19.8133 22.9682 20.0048 22.8245L22.6375 20.85C22.67 20.8257 22.7094 20.8125 22.75 20.8125H28.134ZM27.5625 26.25C27.5625 25.9394 27.3107 25.6875 27 25.6875H22.5C22.1894 25.6875 21.9375 25.9394 21.9375 26.25C21.9375 26.5606 22.1894 26.8125 22.5 26.8125H27C27.3107 26.8125 27.5625 26.5606 27.5625 26.25Z" fill="white" stroke="white" stroke-width="0.375"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M28.875 26.0625C29.1857 26.0625 29.4375 26.3144 29.4375 26.625C29.4375 26.9356 29.1857 27.1875 28.875 27.1875C28.5643 27.1875 28.3125 26.9356 28.3125 26.625C28.3125 26.3144 28.5643 26.0625 28.875 26.0625ZM30.5625 26.625C30.5625 25.6931 29.807 24.9375 28.875 24.9375C27.943 24.9375 27.1875 25.6931 27.1875 26.625C27.1875 27.557 27.943 28.3125 28.875 28.3125C29.807 28.3125 30.5625 27.557 30.5625 26.625Z" fill="white" stroke="white" stroke-width="0.375"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M20.625 26.0625C20.9356 26.0625 21.1875 26.3144 21.1875 26.625C21.1875 26.9356 20.9356 27.1875 20.625 27.1875C20.3144 27.1875 20.0625 26.9356 20.0625 26.625C20.0625 26.3144 20.3144 26.0625 20.625 26.0625ZM22.3125 26.625C22.3125 25.6931 21.5569 24.9375 20.625 24.9375C19.693 24.9375 18.9375 25.6931 18.9375 26.625C18.9375 27.557 19.693 28.3125 20.625 28.3125C21.5569 28.3125 22.3125 27.557 22.3125 26.625Z" fill="white" stroke="white" stroke-width="0.375"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M25.5 18.1875C25.1894 18.1875 24.9375 18.4393 24.9375 18.75V19.5C24.9375 19.8107 25.1894 20.0625 25.5 20.0625C25.8107 20.0625 26.0625 19.8107 26.0625 19.5V18.75C26.0625 18.4393 25.8107 18.1875 25.5 18.1875Z" fill="white" stroke="white" stroke-width="0.375"/>
        </svg>`;

    driverPositionIconRef.current = new google.maps.Marker({
      position: driverPosition,
      optimized: false,
      icon: {
        anchor: new google.maps.Point(16, 16),
        scaledSize: new google.maps.Size(45, 45),
        url: 'data:image/svg+xml;utf-8,' + encodeURIComponent(svg),
      },
      map: map,
    });
    if (fitBounds) {
      const bounds = new google.maps.LatLngBounds();
      bounds.extend(position);
      bounds.extend({ lat: driverPosition.lat, lng: driverPosition.lng });
      if (userPosition && haversineDistance(position, userPosition) < 5) {
        bounds.extend(userPosition);
      }
      map.initialZoom = false;
      map.fitBounds(bounds);
    }
  };
  useEffect(() => {
    return () => {
      navigator.geolocation.clearWatch(positionId);
    };
  }, [positionId]);
  return (
    <div>
      <GeoMap
        className="geo-map"
        position={position}
        handleApiLoaded={handleApiLoaded}
        center={center}
        zoom={zoom}
      />
    </div>
  );
};
